import template from './attendances.html';

/** @ngInject */
function attendancesConfig($stateProvider, modulesProvider) {
  modulesProvider.registerModule({
    title: 'Frekwencje',
    state: 'modules.attendances.byGroup',
    showInMenu: true,
    permissions: ['ALL']
  });

  $stateProvider
    .state('modules.attendances', {
      url: '/attendances',
      abstract: true,
      views: {
        'content@': {
          template,
          controller: 'AttendancesController as ctrl'
        }
      },
      resolve: {
        invalidAttendances: StudentService => StudentService.getAttendances(
          {
            showLoaderSpinner: true,
            invalid: true
          }
        )
      }
    })
    .state('modules.attendances.byGroup', {
      url: '/byGroup',
      views: {
        'attendances@modules.attendances': {
          component: 'attendancesComponent'
        }
      },
      resolve: {
        groups: GroupService => GroupService.getAllGroups(),
        categoriesOfDeparture: CategoryOfDepartureService => CategoryOfDepartureService.getAll()
      }
    })
    .state('modules.attendances.byClass', {
      url: '/byClass',
      views: {
        'attendances@modules.attendances': {
          component: 'attendancesByClassComponent'
        }
      },
      resolve: {
        classRooms: ClassRoomService => ClassRoomService.getClassRooms(),
        categoriesOfDeparture: CategoryOfDepartureService => CategoryOfDepartureService.getAll()
      }
    })
    .state('modules.attendances.invalid', {
      url: '/invalid',
      views: {
        'attendances@modules.attendances': {
          component: 'invalidAttendancesComponent'
        }
      }
    })
    .state('modules.attendances.history', {
      url: '/history',
      views: {
        'content@': {
          component: 'historyAttendancesComponent'
        }
      },
      resolve: {
        historyAttendances: (StudentService, moment) => {
          return StudentService.getAttendances({day: moment().format('YYYY-MM-DD')});
        },
        groups: GroupService => GroupService.getAllGroups(true)
      }
    });
}

export default attendancesConfig;
